import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface initialStateType {
    message: string;
    type?: 'success' | 'info' | 'warning' | 'error';
}

const initialState: initialStateType = {
    message: '',
    type: 'success',
};

const notifierSlice = createSlice({
    initialState,
    name: 'notifier',
    reducers: {
        clearNotifier: (state) => {
            state.message = '';
            state.type = 'success';
        },
        showNotifier: (state, action: PayloadAction<initialStateType>) => {
            state.message = action.payload.message;
            state.type = action.payload.type;
        },
    },
});

export const { showNotifier, clearNotifier } = notifierSlice.actions;
export default notifierSlice.reducer;
